export default __webpack_public_path__ + "static/media/bg-landing.367e394e.webp";